import BarChartAssignmentAverages from './BarChartAssignmentAverages';

const MultiChartAssignmentAveragesDashboard = ({ data }) => {
  if (data?.length === 0) return null;

  const transformedData = {
    sections: data.map((item) => {
      const sectionNumber = item.name.split('-').pop().trim();
      return {
        ...item,
        sectionLabel: `Section ${sectionNumber}`,
      };
    }),
    numericPercentage: data[0]?.numericPercentage,
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        alignItems: 'center',
      }}
    >
      <BarChartAssignmentAverages data={transformedData} />
    </div>
  );
};

export default MultiChartAssignmentAveragesDashboard;
